import React from 'react'
import { Table } from 'antd'
import { useNavigate } from 'react-router-dom'
import useLessonLearned from 'src/Hooks/MentorHooks/useLessonLearned'
import 'src/Pages/LibraryPages/librarypages.scss'

const LessonLearned = () => {
  const token = localStorage.getItem('token')
  const navigate = useNavigate()

  const { data, loading, page, pageSize, total, setPage, setPageSize } = useLessonLearned(token)

  const columns = [
    {
      title: 'Project Id',
      dataIndex: 'projectId',
      key: 'projectId',
    },
    {
      title: 'Project Name',
      dataIndex: 'projectName',
      key: 'projectName',
    },
    {
      title: 'Group Name',
      dataIndex: 'groupName',
      key: 'groupName',
    },
    {
      title: 'Completed Phase',
      dataIndex: 'completedPhase',
      key: 'completedPhase',
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <button
          type="button"
          className="lpg__btn-primary"
          onClick={() => navigate(`/completed-phase/${record.lessonLearnedId}/${record.phaseId}`)}
        >
          Proceed
        </button>
      ),
    },
  ]

  return (
    <div className="lpg">
      <div className="lpg__head">
        <div className="lpg__head-main">
          <span className="lpg__head-ic">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M9 18h6M10 21h4" />
              <path d="M12 3a6 6 0 0 0-4 10.5c.6.7 1 1.5 1 2.5h6c0-1 .4-1.8 1-2.5A6 6 0 0 0 12 3z" />
            </svg>
          </span>
          <div>
            <h1 className="lpg__title">Lessons Learned</h1>
            <p className="lpg__sub">Lessons captured from projects.</p>
          </div>
        </div>
        <button type="button" className="lpg__back" onClick={() => navigate('/projects')}>
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M19 12H5M11 18l-6-6 6-6" />
          </svg>{' '}
          Back
        </button>
      </div>

      {loading ? (
        <div className="lpg__state">
          <div className="lpg__spin" />
          Loading...
        </div>
      ) : (
        <div className="lpg__panel-box">
          <Table
            columns={columns}
            dataSource={data}
            pagination={{
              current: page,
              pageSize,
              total,
              showSizeChanger: true,
              pageSizeOptions: ['10', '20', '30'],
              onChange: (p, s) => {
                setPage(p)
                setPageSize(s)
              },
            }}
          />
        </div>
      )}
    </div>
  )
}

export default LessonLearned
